
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorDeInicio } from './controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorDeInicio;

        @Prop()
        public UltimaBusqueda: string;

        public get Bultos() { return this.Controlador.Bultos; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        
        
    }
